import React, { useLayoutEffect, useRef } from 'react';

export default function MeasuredItem({ id, onHeight, epsilonPx = 2, onFocusWithinChange, children }) {
  const ref = useRef(null);
  const lastHeightRef = useRef(null);
  const rafRef = useRef(0);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const measure = () => {
      const next = el.offsetHeight || 0;
      const prev = lastHeightRef.current;

      if (prev == null || Math.abs(prev - next) >= epsilonPx) {
        lastHeightRef.current = next;
        onHeight(id, next);
      }
    };

    measure();

    const ro = new ResizeObserver(() => {
      cancelAnimationFrame(rafRef.current);
      rafRef.current = requestAnimationFrame(measure);
    });

    ro.observe(el);

    return () => {
      cancelAnimationFrame(rafRef.current);
      ro.disconnect();
    };
  }, [id, onHeight, epsilonPx]);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || !onFocusWithinChange) return;

    const onFocusIn = () => onFocusWithinChange(id, true);
    const onFocusOut = (e) => {
      const next = e.relatedTarget;
      if (next && el.contains(next)) return;
      onFocusWithinChange(id, false);
    };

    el.addEventListener('focusin', onFocusIn);
    el.addEventListener('focusout', onFocusOut);

    return () => {
      el.removeEventListener('focusin', onFocusIn);
      el.removeEventListener('focusout', onFocusOut);
    };
  }, [id, onFocusWithinChange]);

  return (
    <div ref={ref} style={{ width: '100%' }}>
      {children}
    </div>
  );
}
